import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import Chip from '@mui/material/Chip';

const NAV = [
  { label: 'Overview', path: '/admin' },
  { label: 'Organizations', path: '/admin/organizations' },
  { label: 'Users', path: '/admin/users' },
];

export default function AdminLayout({ user, onLogout, children }) {
  const { pathname } = useLocation();
  const navigate = useNavigate();

  const handleLogout = () => {
    onLogout();
    navigate('/login');
  };

  return (
    <Box sx={{ minHeight: '100vh', bgcolor: '#0f172a' }}>
      <AppBar position="static" sx={{ bgcolor: '#1e293b', boxShadow: 'none', borderBottom: '1px solid #334155' }}>
        <Toolbar>
          <Typography variant="h6" fontWeight={700} sx={{ mr: 1 }}>Showing Planner</Typography>
          <Chip label="Admin" size="small" color="warning" sx={{ mr: 4, fontWeight: 700 }} />
          <Box sx={{ display: 'flex', gap: 1, flexGrow: 1 }}>
            {NAV.map(({ label, path }) => (
              <Button
                key={path}
                component={Link}
                to={path}
                color="inherit"
                variant={pathname === path ? 'outlined' : 'text'}
                size="small"
              >
                {label}
              </Button>
            ))}
          </Box>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
            <Typography variant="body2" sx={{ opacity: 0.7 }}>
              {user?.first_name} {user?.last_name}
            </Typography>
            <Button color="inherit" variant="outlined" size="small" onClick={handleLogout}>Logout</Button>
          </Box>
        </Toolbar>
      </AppBar>
      <Box sx={{ p: 4, color: '#f1f5f9' }}>
        {children}
      </Box>
    </Box>
  );
}
